"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const native_base_1 = require("native-base");
const react_1 = require("react");
const colors_1 = require("../../common/colors");
const useDevice_1 = require("../../hooks/useDevice");
const ScrollCustomIndicator_1 = __importDefault(require("../ScrollCustomIndicator"));
const AppText_1 = require("../AppText");
const CloseButton_1 = __importDefault(require("../AppButton/CloseButton"));
const application_host_1 = require("../../common/application-host");
const AppIcons_1 = require("../../component/AppIcons");
const BASE_LANGUAGES = [
    "English",
    "Spanish (Español)",
    "French (Français)",
    "German (Deutsch)",
    "Italian (Italiano)",
    "Portuguese (Português)",
    "Chinese (Simplified) (简体中文)",
    "Japanese (日本語)",
    "Korean (한국어)",
    "Hindi (हिंदी)",
    "Russian (Русский)",
    "Tamil (தமிழ்)",
    "Bengali (বাংলা)",
];
const DEV_LANGUAGES = [
    "Arabic (العربية)",
    "Vietnamese (Tiếng Việt)",
    "Thai (ไทย)",
    "Turkish (Türkçe)",
    "Dutch (Nederlands)",
    "Polish (Polski)",
    "Indonesian (Bahasa Indonesia)",
    "Greek (Ελληνικά)",
    "Punjabi (ਪੰਜਾਬੀ)",
];
const LANGUAGES_LIST = application_host_1.DEV_MODE ? [...BASE_LANGUAGES, ...DEV_LANGUAGES] : BASE_LANGUAGES;
const LanguageSelect = ({ defaultValue, value, onValueChange, onClose, }) => {
    const { isWebDevice, isMobileScreen } = (0, useDevice_1.useDevice)();
    const [selectedLanguage, setSelectedLanguage] = (0, react_1.useState)(value ?? defaultValue);
    return ((0, jsx_runtime_1.jsxs)(native_base_1.VStack, { w: "100%", flex: 1, mt: !(isWebDevice && !isMobileScreen) ? 1 : undefined, alignSelf: "center", justifyContent: "space-between", children: [isWebDevice && !isMobileScreen && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                    backgroundColor: colors_1.Colors.DARK_600,
                    width: '100%',
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                }, children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "space-between", alignItems: "center", backgroundColor: colors_1.Colors.DARK_600, mb: 4, children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { alignItems: "center", space: 2, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: "white", fontSize: 20, lineHeight: 32, mr: 1, children: "Select a language" }), (0, jsx_runtime_1.jsx)(AppIcons_1.AlphaTag, {})] }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClose: onClose, buttonSize: 24, verticalOffset: 12, horizontalOffset: 2 })] }) })), (0, jsx_runtime_1.jsx)(ScrollCustomIndicator_1.default, { customIndicator: !isMobileScreen, style: {
                    backgroundColor: colors_1.Colors.DARK_700,
                    width: '100%',
                    borderRadius: 8,
                    alignContent: "center",
                    alignSelf: "center",
                    paddingTop: isWebDevice && !isMobileScreen ? 6 : 5,
                    paddingBottom: isWebDevice && !isMobileScreen ? 6 : undefined,
                }, children: LANGUAGES_LIST.map((language, index, languagesList) => ((0, jsx_runtime_1.jsx)(native_base_1.Pressable, { onPress: () => {
                        setSelectedLanguage(language);
                        onValueChange(language);
                    }, children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "space-between", pl: isWebDevice && !isMobileScreen ? 6 : 5, pr: isWebDevice && !isMobileScreen ? 6 : 5, borderBottomColor: colors_1.Colors.DARK_600, borderBottomWidth: index !== languagesList.length - 1
                            ? isWebDevice && !isMobileScreen
                                ? 0.5
                                : 1
                            : 0, children: [(0, jsx_runtime_1.jsx)(native_base_1.HStack, { justifyContent: "flex-start", alignItems: "center", space: 2, my: !(isWebDevice && !isMobileScreen) ? 2 : undefined, background: colors_1.Colors.DARK_700, p: isWebDevice && !isMobileScreen ? 3 : undefined, px: !(isWebDevice && !isMobileScreen) ? 3 : undefined, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: isWebDevice && !isMobileScreen ? 'white' : colors_1.Colors.white, fontSize: 16, lineHeight: 22.4, children: language }) }), (0, jsx_runtime_1.jsx)(native_base_1.HStack, { pt: 3, children: (value ?? selectedLanguage) === language && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheck, size: 16, color: colors_1.Colors.PRIMARY_BLUE })) })] }) }, `${language}-list`))) })] }));
};
exports.default = LanguageSelect;
